import { connect } from 'react-redux';
import SAFeed from './components/SAFeed';
import {
  loadFeeds,
  consumeFeedData,
  consumeFileData,
  createGlobalFeed,
  updateGlobalFeed,
  loadGlobalFeeds,
  deleteGlobalFeed,
  verifyAuth,
  resetFeedStatus,
  createVirtualFeed,
  updateVirtualFeed,
} from '../../redux/actions/feed';
import { selectFeedItemFields } from '../../redux/selectors/filters';
import { selectFoundTags } from '../../redux/selectors/tags';
import { resetTagSearch, searchForTags } from '../../redux/actions/tags';

const mapStateToProps = (state) => {
  return {
    error: state.feed.error,
    feedTable: state.feed.tableData,
    consumeStatus: state.feed.consumeStatus,
    saveStatus: state.feed.saveStatus,
    testStatus: state.feed.testStatus,
    message: state.feed.message,
    status: state.feed.globalFeedsStatus,
    globalFeeds: state.feed.globalFeeds,
    feedItemFields: selectFeedItemFields(state),
    foundTags: selectFoundTags(state),
    searchStatus: state.tags.searchStatus,
    user: state.user.user,
  };
};

const mapDispatchToProps = {
  loadFeeds,
  consumeFeedData,
  consumeFileData,
  createGlobalFeed,
  updateGlobalFeed,
  loadGlobalFeeds,
  deleteGlobalFeed,
  verifyAuth,
  resetFeedStatus,
  createVirtualFeed,
  updateVirtualFeed,
  searchForTags,
  resetTagSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SAFeed);
